//index.js
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter,Routes, Route } from 'react-router-dom';
import { ChoosePlan } from './ChoosePlan';
import MainLandingPage from './Components/LandingPages/MainLandingPage';
import PaymentPage from './PaymentPage';
import ExitTransitionPage from "./Components/LandingPages/exitpage/ExitTransitionPage";
import { ProtectedRoute } from './Components/Auth/ProtectedRoute';
import { AuthProvider } from './Components/Auth/AuthContext';  // Import Auth Context
import { LoginPage } from './Components/Routes/LoginPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsConditionsModal from './TermsAndConditions';
import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from './Components/Auth/AuthContext';
import AdminLandingPage from './Components/Admin/AdminLandingPage';

const ThemeWrapper = ({ children }) => {
  const location = useLocation();
  const { applyWebsiteTheme } = useAuthContext();

  useEffect(() => {
      // Apply dark theme for all pages EXCEPT portal (/landingPage)
      const isPortal = location.pathname.startsWith('/landingPage') || location.pathname.startsWith('/admin');
      if (!isPortal) {
          applyWebsiteTheme();
      }else {
        // Apply saved portal theme for both /landingPage and /admin
        const savedTheme = localStorage.getItem("portalTheme") || "light";
        document.documentElement.setAttribute("theme", savedTheme);
      }
  }, [location.pathname, applyWebsiteTheme]);

  return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AuthProvider> {/* 🔹 Wrap the entire app in AuthProvider */}
    <BrowserRouter>
    <ThemeWrapper>
    <Routes>
        {/* Root route without a header */}
         <Route path="/" element={<App />} />
         <Route path="/landingPage" element={<ProtectedRoute role="student"><Navigate to="/landingPage/profile" replace /></ProtectedRoute>} />
         <Route path="/landingPage/:section" element={<ProtectedRoute role="student"><MainLandingPage /></ProtectedRoute>} />
        <Route path="/admin/*" element={
          <ProtectedRoute role="university_admin">
            <AdminLandingPage />
          </ProtectedRoute>
        } />
        <Route path="/exit" element={<ProtectedRoute><ExitTransitionPage /></ProtectedRoute>} />
        {/* <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} /> */}
        <Route path="/pricing" element={<ProtectedRoute><ChoosePlan /></ProtectedRoute>} />
        <Route path="/payment" element={<ProtectedRoute><PaymentPage/></ProtectedRoute>} /> 
        <Route path="/login" element={<LoginPage />}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsConditionsModal />} />
{/*   

     <Route path="/landingPage" element={<MainLandingPage />} />
       <Route path="/exit" element={<ExitTransitionPage />} />
       <Route path="/pricing" element={<ChoosePlan />} />
       <Route path="/payment" element={<PaymentPage/>} />   */}
        
      </Routes>
      </ThemeWrapper>
    </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
 
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();